module.exports = __webpack_public_path__ + "img/image.09816ff0.svg";